import { CanoeIcon, css, styled } from 'canoe';
import React from 'react';

const StyledLabel = styled.div`
  ${({ theme }) => css`
    position: absolute;
    right: 0;
    z-index: 4;
    display: flex;
    font-weight: 600;
    font-size: ${theme.fonts.small.fontSize};
    color: ${theme.colors.BrandPurpleL10};
    border-bottom-left-radius: ${theme.borderRadius.xsmall};
    padding: 3px ${theme.spaces.xs};
    background-color: #ece8ff;
    user-select: none;
    transition: ${theme.transitions.default('opacity')};

    &:hover {
      opacity: 0.2;
    }
  `}
`;

export interface FloatingLabelProps {
  label?: string;
  icon: CanoeIcon;
}

export const FloatingLabel = ({ label, icon: LabelIcon }: FloatingLabelProps) => {
  return (
    <StyledLabel>
      <LabelIcon mr="xxs" size="s" color="BrandPurpleL10" />
      {label}
    </StyledLabel>
  );
};
